import { DeepPartial, Messages } from '@empathybroker/ebx-gluon';

export const es: DeepPartial<Messages> = {
  resultsFoundHTML: '<span class="ebx-results-number__count">{resultsNumber}</span> resultados',
  nextQueriesSuggestions: {
    title: 'Quien buscó {query} también buscó...'
  },
  search: {

    inputPlaceholderAlternativesHTML: ['¿Qué estás buscando?']
  },
  facets: {
    clearFilters: 'Limpiar filtros',

    toggle: {
      groups: {
        'all-facets': {
          outside: {
            openHTML: 'Mostrar <span class="ebx-panel-toggle__numFound">({selectedFiltersCount})</span> filtros',
            closeHTML: 'Ocultar filtros'
          }
        }

      }

    }
  },

  nextQueries: {
    titleHTML: ''
  },
  sort: {
    titleHTML: 'Ordenar por {selectedItem}',
    sortTitles: {
      default: 'Relevancia',
      priceAsc: 'Precio ascendente',
      priceDesc: 'Precio descendente',
      alphabeat: 'Alfabeticamente'
    }
  },
  results: {
    addToCart: 'Añadir a la cesta'
  },
  noResults: {
    messageHTML: `<span class="ebx-no-results__mgoccessage-apologies">No hemos encontrado resultados para </span>
         <span class="ebx-no-results__message-query">'{query}'</span><span class="ebx-no-results__message-try-again">
        Estos son los productos más vistos hoy</span>`
  }
};
